<template>
    <Modal>
        <template #title>Edit permission denied</template>

        <p>Trim <b>{{ trimName }}</b> is currently opened in edit mode by user: <b>{{ openedBy }}</b></p>
        <p>You can view it but <b>not edit</b> this trim for now.</p>

        <template #footer>
            <Button @click="closeModal">OK</Button>
        </template>
    </Modal>
</template>

<script>
    import Modal from "../Modal";
    import Button from "../Button";

    export default {
        name: "PermissionToEditModal",

        components: {
            Button,
            Modal,
        },

        props: [
            'trimName',
            'openedBy',
        ],

        methods: {
            closeModal() {
                this.$emit('closeModal');
            },

        },

    }
</script>

<style>

</style>